import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValgSortHeaderComponent } from "@valg-shared/components/table/table/valg-sort-header/valg-sort-header.component";
import { MatIconModule } from "@angular/material/icon";
import { ValgInputModule } from '@valg-shared/components/input/input.module';


@NgModule({
  declarations: [ ValgSortHeaderComponent ],
  exports: [ ValgSortHeaderComponent ],
    imports: [
        CommonModule,
        MatIconModule,
        ValgInputModule
    ]
})
export class ValgSortHeaderModule { }
